import { Directive, ElementRef, ViewContainerRef } from '@angular/core';

@Directive({selector: '[appControlErrorOutlet]'})
export class ControlErrorOutletDirective {
  constructor(public viewContainer: ViewContainerRef, public elementRef: ElementRef) {}
}
